import React from 'react'

function Modal({ handleClose, show, children }) {
    const showHideClassName1 = show ? "modal display-block" : "modal display-none";
    return (
        <div className={showHideClassName1}>
        <section className="modal-main">
        <div className="modal-cancel"  onClick={handleClose} >Close X</div>
          {children}
         
          <div className="link-cancel"  onClick={handleClose} >No, continue</div>
        </section>
      </div>
    )
}

export default Modal
